import React from "react";
import { StyleSheet, View, Text } from "react-native";
import { Color, globalFontStyle } from "../../../assets";
import MarketResolution from "./MarketResolution";
import OrderBook from "./OrderBook";
import ListOfTrades from "../../portfolio/childComponents/listOfTrades";
import { globalConfigurableData, GlobalScreens } from "../../../utils/globalConstant";
import { Icon } from '@iconify/react';
import { Accordion } from "../../../components/core/Accordion";

export const EventDetailsBox = ({
  text,
  title,
  eventDetails,
  onOrderBookClick,
  _eventInfo,
  isSelected = false,
  isListOfTrades,
  isAboutSection = false,
}) => {
  const renderContent = () => {
    if (isAboutSection) {
      return text;
    } else if (text) {
      return (
        <MarketResolution
          resolutionData={text}
          source={_eventInfo?.source}
          full_rules={_eventInfo?.full_rules}
        />
      );
    } else if (isListOfTrades) {
      return <ListOfTrades orderList={isListOfTrades} />;
    } else {
      return (
        <OrderBook
          eventDetails={eventDetails}
          event={_eventInfo}
          onOrderBookClick={onOrderBookClick}
        />
      );
    }
  };

  const customTrigger = (
    <View style={styles.eventDetailTitle}>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        {title === 'Market Stats and Timeline' && (
          <Icon 
            icon="tabler:calendar-time"
            style={{ width: 24, height: 24 }}
            color={globalConfigurableData.primaryTextColor1}
          />
        )}
        {title === 'Market Resolution(MR)' && (
          <Icon 
            icon="tabler:gavel"
            style={{ width: 24, height: 24 }}
            color={globalConfigurableData.primaryTextColor1}
          />
        )}
        {title === 'Orderbook' && (
          <Icon 
            icon="tabler:book"
            style={{ width: 24, height: 24 }}
            color={globalConfigurableData.primaryTextColor1}
          />
        )}
        <Text style={[
          globalFontStyle.appFontSubTextBold,
          { 
            marginLeft: 12,
            color: globalConfigurableData.primaryTextColor1
          }
        ]}>
          {title}
        </Text>
      </View>
    </View>
  );

  return (
    <View style={styles.eventDetailsBox}>
      <Accordion
        defaultValue={true}
        trigger={customTrigger}
        content={renderContent()}
        style={styles.accordion}
        contentStyle={styles.accordionContent}
        iconColor={globalConfigurableData.primaryTextColor1}
        showIcon={true}
        triggerStyle={{
          padding: 0,
          backgroundColor: 'transparent',
        }}
        onValueChange={(value) => {
          // Initialize animation immediately after mount
          if (!value) {
            setTimeout(() => {
              value = true;
            }, 0);
          }
        }}
      />
    </View>
  );
};

export default EventDetailsBox;

const styles = StyleSheet.create({
  eventDetailsBox: {
    marginBottom: 15,
  },
  eventDetailTitle: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
  },
  accordionContent: {
    padding: 0,
  },
});
